import { DialogTitle, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface ModalHeaderProps {
  onClose: () => void
}

export const ModalHeader = ({ onClose }: ModalHeaderProps) => (
  <DialogTitle
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      pt: 4,
      px: 4,
      pb: 1,
    }}
  >
    <Typography component="span" variant="h6">
      Share request
    </Typography>
    <IconButton onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>
)
